import { useState, useEffect, useCallback } from 'react';
import newsService from '../services/newsService';

export const useNews = () => {
  const [news, setNews] = useState([]);
  const [newsOffset, setNewsOffset] = useState(0);
  const [hasMoreNews, setHasMoreNews] = useState(false);
  const [loadingNews, setLoadingNews] = useState(true);
  const [latestNewsDate, setLatestNewsDate] = useState(null);
  const [error, setError] = useState(null);

  const loadLatestNewsDate = useCallback(async () => {
    try {
      const data = await newsService.getLatestNewsDate();
      setLatestNewsDate(data.latestDate);
    } catch (error) {
      console.error('Error loading latest news date:', error);
      setError(error.message);
    }
  }, []);

  const loadNews = useCallback(async (offset = 0, append = false) => {
    setLoadingNews(true);
    setError(null);
    try {
      const data = await newsService.getNews(10, offset);
      if (append) {
        setNews(prev => [...prev, ...data.news]);
      } else {
        setNews(data.news);
      }
      setNewsOffset(offset);
      setHasMoreNews(data.hasMore);
    } catch (err) {
      console.error('Error loading news:', err);
      setError(err.message);
    } finally {
      setLoadingNews(false);
    }
  }, []);

  const loadMoreNews = useCallback(() => {
    const newOffset = newsOffset + 10;
    loadNews(newOffset, true);
  }, [newsOffset, loadNews]);

  const refreshNews = useCallback(() => {
    setNewsOffset(0);
    loadNews(0, false);
    loadLatestNewsDate();
  }, [loadNews, loadLatestNewsDate]);

  useEffect(() => {
    loadNews();
    loadLatestNewsDate();
  }, [loadNews, loadLatestNewsDate]);

  return {
    news,
    loadingNews,
    hasMoreNews,
    latestNewsDate,
    error,
    loadMoreNews,
    refreshNews,
  };
};
